import { Text } from '#atoms';
import { useSearchMemberQuery } from '#hooks/queries/member/useSearchMemberQuery';
import { useScheduleManage } from '#providers/SchedulesManage';
import { debounce } from 'lodash';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import Icon from 'src/components/atoms/Icon';
import Loading from 'src/components/molecules/Loading';
import SearchMember from './SearchMember';
import * as S from './styles';
import useScheduleMembership from '#pages/WeeklyCalenderScheduleRegistration/LectureScheduleContents/useScheduleMembership';

export function WeeklyCalenderSearch() {
  const { setMembership } = useScheduleMembership();

  const [searchValue, setSearchValue] = useState<string>('');

  const navigate = useNavigate();

  const { data: memberList, isLoading } = useSearchMemberQuery({
    name: searchValue
  });
  const { selectedLecture, setSelectedLecture, groupMembers, setGroupMembers } =
    useScheduleManage();

  const [selectedGroupMembers, setSelectedGroupMembers] = useState<
    {
      personName: string;
      personId: string;
    }[]
  >(groupMembers);

  const handleChangeInput = debounce((value: string) => {
    setSearchValue(value);
  }, 300);

  const selectUser = (name: string, id: string) => {
    setMembership({
      lectureName: '',
      lectureId: '',
      completedRoundUntilNow: 0,
      totalRound: 0,
      confirmationFormId: ''
    });
    if (selectedLecture.isGroup) {
      // 이미 포함되어 있다면 제거
      if (selectedGroupMembers.some(member => member.personId === id)) {
        setSelectedGroupMembers(prev =>
          prev.filter(member => member.personId !== id)
        );
        return;
      }

      setSelectedGroupMembers(prev => [
        ...prev,
        { personName: name, personId: id }
      ]);
    } else {
      setSelectedLecture({
        personName: name,
        personId: id
      });

      navigate(-1);
    }
  };

  const onSave = () => {
    if (selectedLecture.isGroup) {
      setGroupMembers(
        selectedGroupMembers.map(member => ({
          personId: member.personId,
          personName: member.personName,
          round: 0,
          totalRound: 0
        }))
      );
    }
    navigate(-1);
  };

  return (
    <>
      {selectedLecture.isGroup && (
        <S.ButtonSubmit
          style={{ position: 'fixed', top: '16px', right: '20px', zIndex: 2 }}
          onClick={onSave}
        >
          저장
        </S.ButtonSubmit>
      )}

      <S.Container>
        <S.Header>
          <Text>회원 목록</Text>
        </S.Header>
        <S.SearchBox>
          <SearchMember onChange={handleChangeInput} />
          <S.ButtonAdd onClick={() => navigate('/client-registration')}>
            <Icon name="IconPlus" />
          </S.ButtonAdd>
        </S.SearchBox>
        <S.List>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              {memberList && memberList.length === 0 ? (
                <S.SearchFailBox>
                  <Text>검색 결과가 없습니다.</Text>
                </S.SearchFailBox>
              ) : (
                memberList?.map(user => {
                  const isSelected = selectedLecture?.isGroup
                    ? selectedGroupMembers.some(
                        member => member.personId === user.personId
                      )
                    : user.personId === selectedLecture?.personId;

                  return (
                    <S.User
                      key={user.personId}
                      isSelected={isSelected}
                      onClick={() => selectUser(user.name, user.personId)}
                    >
                      <Text>{user.name}</Text>
                    </S.User>
                  );
                })
              )}
            </>
          )}
        </S.List>
      </S.Container>
    </>
  );
}
